import * as React from 'react';

import {TooltipRow} from './tooltip-row';
import {TooltipTotalsRow} from './tooltip-totals-row';
import type {TooltipRowData} from './tooltip-types';

import styles from './tooltips.module.css';

type TooltipTableProps = {
    detailRows: Array<TooltipRowData>;
    totalRow?:
        | {
              count: number | null | undefined;
              total: number | null | undefined;
          }
        | null
        | undefined;
    quotaRow?: TooltipRowData | null | undefined;
    currencyPrefix: string;
    headingText?: string;
};
export function TooltipTable({
    detailRows,
    totalRow,
    quotaRow,
    currencyPrefix,
    headingText,
}: TooltipTableProps) {
    const hasTotalFacet = detailRows.every(
        (row) => row.rowData.total !== null && row.rowData.total !== undefined
    );

    return (
        <div className={styles['tooltip-table-container']}>
            <h4 className={styles['tooltip-heading']}>{headingText || '\u00A0'}</h4>
            {/* An nbsp to keep vert padding */}
            <table
                className={
                    hasTotalFacet ? styles['tooltip-table'] : styles['tooltip-table--full-width']
                }
            >
                <tbody>
                    {detailRows.map((row) => (
                        <TooltipRow
                            key={row.name}
                            row={row}
                            isPaddedTop={false}
                            currencyPrefix={currencyPrefix}
                        />
                    ))}
                    {totalRow ? (
                        <TooltipTotalsRow
                            count={totalRow.count}
                            total={totalRow.total}
                            currencyPrefix={currencyPrefix}
                        />
                    ) : undefined}
                    {quotaRow ? (
                        <TooltipRow
                            key={'quota'}
                            row={quotaRow}
                            isPaddedTop={true}
                            currencyPrefix={currencyPrefix}
                        />
                    ) : undefined}
                </tbody>
            </table>
        </div>
    );
}
